import * as React from "react";
import { useState } from "react";
import SuggestionsList from "components/common/EntityFilters/FilterConfiguration/SuggestionsList";
import useUsersAndTeams from "security-app/components/Investigations/hooks/useUsersAndTeams";
import { useGetTeams, useGetUsers } from "security-app/hooks/useInvestigationsAPI";
import { assigneeSuggestions } from "./assigneeSuggestions";
const DEFAULT_SEARCH_PARAMS = {
  query: "",
  page: 1,
  pageSize: 10
};
const AssigneeFilter = ({
  allActiveFilters,
  attribute,
  filter = void 0,
  filterValueRenderer,
  onSubmit
}) => {
  const [searchParams, setSearchParams] = useState(DEFAULT_SEARCH_PARAMS);
  const usersAndTeams = useUsersAndTeams();
  const { loadingUsers } = useGetUsers();
  const { loadingTeams } = useGetTeams();
  const { suggestions, total } = assigneeSuggestions(Object.values(usersAndTeams), searchParams);
  return /* @__PURE__ */ React.createElement(
    SuggestionsList,
    {
      isLoading: loadingUsers || loadingTeams,
      total,
      page: searchParams.page,
      pageSize: searchParams.pageSize,
      setSearchParams,
      allActiveFilters,
      attribute,
      multiSelect: !filter,
      filterValueRenderer,
      onSubmit,
      suggestions
    }
  );
};
export default AssigneeFilter;
